import Vue from 'vue'
import rpc from '../rpc.js'

function initialState() {
    return {
        galleriesById: {},
        tokensById: {},
        loginError: ""
    }
}

export default {
    namespaced: true,
    state: initialState,
    mutations: {
        gotTokenForGallery(state, {id, token}) {
            Vue.set(state.tokensById, id,  token);
        },
        loginError(state, error) {
            state.loginError = error;
        },
        gotGallery(state, {id, gallery, passwordNeeded}) {
            Vue.set(state.galleriesById, id, {id, ...gallery, passwordNeeded});
            console.log(state)
        }
    },
    actions: {
        loginForGallery({commit, dispatch}, {id, password}) {
            rpc.request("ImageService.GetTokenForPublicGallery", {id: id, password: password}).then(resp => {
                console.log(resp)
                document.cookie = "ii_gallery_cookie=" + resp.token + ";path=/;SameSite=Strict";
                console.log(document.cookie)
                dispatch("getGallery", id)
                commit("gotTokenForGallery", {id: resp.id, token: resp.token})
            }).catch(err => {
                commit("loginError", err)
            })
        }, 
        getGallery({commit}, id) {
            console.log("get gallery", document.cookie)
            rpc.request("ImageService.GetPublicGallery", id).then(resp => {
                console.log(resp)
                commit("gotGallery", {id: id, gallery: resp.gallery, passwordNeeded: resp.passwordNeeded})
            }).catch(err => {
                console.log(err)
                commit("loginError", err)
            })
        }
    }
}